import { FunctionComponent, PropsWithChildren, ReactElement } from 'react';

import { FormControl } from '@mui/material';
import FormHelperText from '@mui/material/FormHelperText';

import DragAndDrop from '../../../../../shared/components/drag-and-drop/DragAndDrop';
import { FormikDragAndDropProps } from './models/formik-drag-and-drop.props';

export const FormikDragAndDrop: FunctionComponent<FormikDragAndDropProps> = (
  props: PropsWithChildren<FormikDragAndDropProps>
): ReactElement => {
  const {
    setFileHandler,
    clearFileHandler,
    fileType,
    fileTypeAccepted,
    files,
    multiple = false,
    label,
    fieldDescription,
    field: { name },
    form: { errors, touched },
  } = props;
  return (
    <FormControl sx={{ flexWrap: 'wrap' }}>
      <DragAndDrop
        name="upload-images-dnd"
        key="images-drag-and-drop"
        uploadHandler={setFileHandler}
        removeHandler={clearFileHandler}
        multiple={multiple}
        files={files}
        label={label}
        isRequired={true}
        hasError={!!errors[name] && !!touched[name]}
        fileType={fileType}
        helperText={fieldDescription}
        buttonLabel="Browse files"
        fileTypeAccepted={fileTypeAccepted}
        previewType={fileType}
      ></DragAndDrop>

      {touched[name] && !!errors[name] && (
        <FormHelperText error>{errors[name]}</FormHelperText>
      )}
    </FormControl>
  );
};
